import { Spacer as ChakraSpacer, type SpacerProps as ChakraSpacerProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends ChakraSpacerProps {}

export default forwardRef<HTMLDivElement, Props>((props, ref) => {
  return <ChakraSpacer ref={ref} {...props} />
})